import ApiService from "./api.service";

const DMSService = {
  getPresignedUrl(payload) {
    return ApiService.post("/dms/signature", payload);
  },
  createFolder(payload) {
    return ApiService.post("/dms/folder", payload);
  },
  getFolders(payload) {
    console.log("getFolders payload", payload);
    return ApiService.query("/dms/folders", {params: payload});
  },
  createFile(payload) {
    return ApiService.post("/dms/file", payload);
  },
  getFiles(payload) {
    return ApiService.query("/dms/files", {params: payload});
  }
}

export default DMSService;
